module.exports = __webpack_public_path__ + "img/mvlivelogo.0efc25ca.svg";